import { RootContainer } from '../../../core/root_container';
import { ItemAction } from '../../actions/item_action';
import { ItemJsEnv } from '../../models/item_js_env';
import { ItemBody, ItemBodySecond } from './item_body';
import { FeedbackContainer } from '../../../core/views/pc/review/feedback_container';
import { LargeCommercialPackAction } from '../../actions/large_commercial_pack_action';
import { AddCartModalAction } from '../../../core/actions/add_cart/modal_action';
import { DeliveryCountdown } from './delivery_countdown';
import { StockAreaContainer } from './stock_area_container';
import { ItemDetailRrAction } from '../../actions/item_detail_rr_action';
import { ItemExpansionModal } from '../../models/item_expansion_modal';
import { RegularItemPriceAction } from '../../actions/regular_item_price_action';

export class ItemContainer extends RootContainer<ItemJsEnv> {
  constructor(model: ItemJsEnv) {
    super();
    this.mount(ItemBody, 'js-item-body');
    this.mount(ItemBodySecond, 'js-item-body-second');

    model.reviewJSOptions.forEach((opt) => {
      FeedbackContainer.init(opt.feedBackModel);
      // R1で商品詳細とバリエーション一覧画面の「編集」「削除」非表示
      // DeleteLinkContainer.init(opt.deleteReviewModel);
    });

    // 在庫エリアのコンテナの初期化
    StockAreaContainer.init(model);

    // 初回描画
    this.update(model);

    // カゴモーダルの初期化
    AddCartModalAction.init();

    // カゴモーダルのRRレコメンド設定
    const addCartButtons = document.getElementsByClassName("cartAreaAddCart");
    const addCartButtonArr = Array.from(addCartButtons);
    addCartButtonArr.forEach((addCartButton) => {
      /// カゴに入れるボタン押下
      addCartButton.addEventListener('click', (e) => {
        /// カゴ投入ボタンが押下されていることを確認する
        const target = e.target as HTMLElement;
        if (target.tagName === 'BUTTON') {
          const targetCatalogItemCode = target.dataset.catalogItemCode as string;
          ItemDetailRrAction.addCartButtonRrRecommend(targetCatalogItemCode);
        }
      });
    });

    // カルーセルのイベント
    const WindowCarousel = window._carousel;
    if (document.getElementById('js-item-body')) {
      new WindowCarousel('.js-carousel', '#js-item-body'); // NOSONAR
    }
    if (document.getElementById('js-item-body-second')) {
      new WindowCarousel('.js-carousel', '#js-item-body-second'); // NOSONAR
    }

    // item pageを更新するイベント
    ItemAction.UPDATE_EVENT.on((newModel: ItemJsEnv) => {
      this.update(newModel);
    });

    /// 大業パまとめ買い表の一定期間表示しないチェッボックスを選択した場合の処理
    document.getElementById('hideCommercialPackCheckbox')?.addEventListener('change', function () {
      LargeCommercialPackAction.changeCommercialPackCheckbox();
    });

    /// 大業パ商品に対して数量変更を行った場合の処理
    // 数量選択がプルダウン
    document
      .querySelector('[data-cart-quantity="select"]')
      ?.addEventListener('change', function (event) {
        const target = event.currentTarget as HTMLSelectElement;
        LargeCommercialPackAction.changeCartQuantity(Number(target.value));
      });
    // 数量選択がテキストインプット
    document
      .querySelector('[data-cart-quantity="input"]')
      ?.addEventListener('change', function (event) {
        const target = event.currentTarget as HTMLInputElement;
        LargeCommercialPackAction.changeCartQuantity(Number(target.value));
      });

    /// 定期便商品に対して数量変更を行った場合の処理
    // 数量選択がプルダウン
    document
      .getElementById('item-regular-delivery-quantity-select')
      ?.addEventListener('change', function (event) {
        const target = event.currentTarget as HTMLSelectElement;
        RegularItemPriceAction.changeCartQuantity(model, Number(target.value));
      });
    // 数量選択がテキストインプット
    document
    .getElementById('item-regular-delivery-quantity-input')
      ?.addEventListener('change', function (event) {
        const target = event.currentTarget as HTMLInputElement;
        RegularItemPriceAction.changeCartQuantity(model, Number(target.value));
      });

    // 在庫表示エリアの文言更新
    DeliveryCountdown.updateElement(model.stockAreaJSOption.addressChoiceModel);

    /// レビューを書くボタン　計測
    document.querySelectorAll('.m-btn.-base.-small.-short,button[data-url]')
      .forEach((button, index, array) => {
        button.addEventListener('click', () => {
          ItemAction.reviewButton(button, index, array);
        });
      });

    /// おすすめの関連商品 AdobeAnalytics
    document
      .querySelectorAll('#js-item-body .swiper-wrapper .m-simpleitemcard_link')
      .forEach((e) => {
        e.addEventListener('click', () => {
          ItemAction.relatedItem(e);
        });
      });

    /// 一緒にかご投入
    document
      .querySelectorAll('.m-btn.-primary.-small.-weightNormal.-short.js-togetherItems_btn')
      .forEach((buttonElm) => {
        buttonElm.addEventListener('click', () => {
          ItemAction.cartAddTogether(
            buttonElm,
            document.querySelectorAll('.a-checkbox.js-togetherItems_checkbox:not(.is-disabled)')
          );
        });
      });

    /// バリエーション一覧へリンク押下時
    document.getElementById('js-variation-list-link')?.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      ItemAction.variationLinkAnalytics(target);
    });

    /// 通常商品から定期配送に切替を行った場合の処理
    document.getElementById('js-regular-delivery')?.addEventListener('change', (e) => {
      const target = e.target as HTMLElement;
      ItemAction.regularDeliveryAnalytics(target, true);
    });

    /// 定期配送から通常商品に切替を行った場合の処理
    document.getElementById('js-non-regular-delivery')?.addEventListener('change', (e) => {
      const target = e.target as HTMLElement;
      ItemAction.regularDeliveryAnalytics(target, false);
    });

    /// 商品詳細リストをクリックしたの処理
    document.
      querySelectorAll('div[data-modal-id=\'modal01\'] .o-carousel.js-carousel button[data-mainsrc]').
      forEach((element, index, array) => {
        element.addEventListener('click', function () {
          ItemAction.itemImageDetailClickAnalytics(<HTMLElement>element, index + 1, array.length);
        });
      });
    /// 商品詳細画面をクリックしたの処理
    const itemElement = document.
      getElementsByClassName('o-productdetailvisual_main_inner js-scale-image_target js-switch-image_main js-switchimagemodal-btn')[0];
    itemElement.addEventListener('click', function () {
      const index = document.
        querySelector('#modal01-content .o-switchimagemodal_main_image.js-switchimagemodal_mainImage.js-switch-image_main')?.
        getAttribute('data-img-index');
      const pictureIndex = parseInt(index == null ? '0' : index) + 1;
      const length = document.
        getElementsByClassName('o-productdetailvisual_thumb js-switch-image_thumb js-switchimagemodal-btn -hoverType').length;
      ItemAction.itemImageDetailClickAnalytics(<HTMLElement>itemElement, pictureIndex, length);
    });

    /// 商品拡大表示モーダル内の画像押下時の処理
    document.querySelectorAll('#modal01 li button[data-mainsrc*=\'.jpg\']')
      .forEach((e, index, array) => {
        e.addEventListener('click', () => {
          ItemAction.MoadlAdobeAnalytics(e, index, array);
        });
      });

    /// 商品拡大表示モーダル(動画) 画像押下時の処理
    ItemExpansionModal.itemExpansionModalCaseItemMovie(model);
  }
}
